(function($) {
  /* ==== CLIENTS ==== */

  if ($('body').hasClass('post-type-archive-client')) {
    /**
     * Define variables
     */
    var loadMoreButton = $('#load-more-clients');
    var postPerPage = loadMoreButton.attr('data-post-per-page');
    var paged = 1;
    var searchInput = $('#search-clients');
    var searchButton = $('#search-clients-button');

    /**
     * Init accordion
     */
    function clientShowMore(button) {
      var show = button.attr('data-show');
      var target = button
        .parent()
        .parent()
        .parent()
        .find('.client-informations');

      if (show === 'more') {
        button.find('.more').hide();
        button.find('.less').show();
        target.stop().slideDown(200);
        button.attr('data-show', 'less');
      } else {
        button.find('.more').show();
        button.find('.less').hide();
        target.stop().slideUp(200);
        button.attr('data-show', 'more');
      }
    }

    $('.see-more-client').each(function() {
      $(this).click(function(e) {
        e.preventDefault();
        clientShowMore($(this));
      });
    });

    /**
     * Load More Members Button
     */
    loadMoreButton.click(function(e) {
      e.preventDefault();
      loadMoreClients();
    });

    /**
     * Load More Members
     */
    function loadMoreClients(resetList = false) {
      loadMoreButton.attr('disabled', true);

      searchInput.attr('disabled', true);
      searchButton.attr('disabled', true);

      var searchValue = searchInput.val();

      if (resetList) {
        paged = 0;
      }

      var loader = loadMoreButton.next('.members__loading');
      loader.show();

      paged++;

      $.ajax({
        type: 'POST',
        url: ajax_object.ajaxurl,
        action: 'load_more_clients',
        data: {
          action: 'load_more_clients',
          paged: paged,
          postPerPage: postPerPage,
          searchValue: searchValue,
        },
        success: function(data) {
          var $data = $(data);

          if ($data.length) {
            $('.clients__no-result').addClass('d-none');

            var ajaxContainer = $('#ajax-clients');

            if (resetList) {
              ajaxContainer.html($data);
            } else {
              ajaxContainer.append($data);
            }

            $data.find('.see-more-client').each(function() {
              $(this).click(function(e) {
                e.preventDefault();
                clientShowMore($(this));
              });
            });

            loadMoreButton.show();
            loadMoreButton.attr('disabled', false);
          } else {
            loadMoreButton.hide();
            $('#total-clients').text('0');
            $('.clients__no-result').removeClass('d-none');
          }

          var totalClients = $('#total-clients').val();
          $('#totalClients').html(totalClients);

          var totalPages = $('#total-pages').val();

          if (totalPages <= paged) {
            loadMoreButton.attr('disabled', true);
            loadMoreButton.hide();
          } else {
            loadMoreButton.attr('disabled', false);
            loadMoreButton.show();
          }

          searchInput.attr('disabled', false);
          searchButton.attr('disabled', false);

          loader.hide();
        },
        error: function(response) {
          console.log('An error occurred while trying to fetch more clients.');
          console.log(response);

          searchInput.attr('disabled', false);
          searchButton.attr('disabled', false);

          loader.hide();
        },
      });
      return false;
    }

    /**
     * Search Input - Keypress trigger
     */
    searchInput.on('keypress', function(e) {
      if (e.which == 13) {
        // Enter
        searchClients();
      }
    });

    /**
     * Search Button - Click handler
     */
    searchButton.click(function(e) {
      e.preventDefault();
      searchClients();
    });

    /**
     * Search Members
     */
    function searchClients() {
      var searchValue = searchInput.val();
      var searchMinimumCharWarning = searchInput
        .parent()
        .find('.filters__search-error')
        .first();

      if (searchValue.length < 3 && searchValue.length > 0) {
        searchMinimumCharWarning.removeClass('d-none');
      } else {
        searchMinimumCharWarning.addClass('d-none');

        paged = 0;
        $('#ajax-members').empty();

        loadMoreClients(true);
      }
    }
  }
})(jQuery);
